export const isOwnDriverHandoverRequest = (payload, driverId) => {
  if (
    payload?.type !== "delivery_handover_request" ||
    payload?.requested_by?.type !== "driver" ||
    payload?.requested_by?.id == null ||
    driverId == null
  ) {
    return false;
  }

  return Number(payload.requested_by.id) === Number(driverId);
};
